module.exports = __webpack_public_path__ + "img/truck.bcc5c615.svg";